<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only">
    <v-checkbox
      style="margin-top:0"
      v-model="model"
      :label="label"
      :prepend-icon="prepend_icon"
      :append-icon="append_icon"
      />
  </pre_input>
</template>

<script>
import filter_rq from './filter_rq';
import pre_input_js from '@/components/mixins/pre_input';
export default {
  props:{
    f_key:{},
    default_value:{},
  },
  mixins: [ filter_rq,pre_input_js ],
  data(){
    return {
      model: null,
      reset_on_value_change:true,
      filter_rq_type:['>'],
    }
  },
  computed: {
    k_f(){ return this.f_key || `s__${this.item_key}` },
    c_value_key() {return this.value_key || this.item_key},
  },
  watch: {
    'model'(v,v_old){
      this.upd()
    },
  },
  beforeMount(){
    this.model = this.value === null && this.default_value && this.myRequestStatus_filter[this.k_f] === this.value
      ? this.default_value
      : this.value;
  },
  created(){

  },
  methods: {
    set_model() {
      this.model = this.value;
      const ex_f = {};
      ex_f[this.k_f] = this.value;
      this.pre_get(ex_f,this.k_f);
      this.get_rq(ex_f);
    },
    upd(){
      this.$emit('update:value', this.model===false?null:this.model);
      //this.myRequestStatus_filter[this.k_f] = this.model;
      //Object.assign(this.myRequestStatus_filter,this.main_filter)
    },
    /* los elementos retornados no afectan las opciones de este filtro */
    then_get_rows(r) { return r },
  },
};
</script>
